import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from 'theme/withStyles';
import { withFieldProps } from 'hooks/useFieldProps';
import RawHtml from 'common/RawHtml';
import rootStyles from './styles/root';

const styles = ({ spacing, typography }) => ({
  root: {
    ...rootStyles({ spacing }),
    '& h1': {
      ...typography.h1,
    },
    '& h2': {
      ...typography.h2,
    },
    '& h3': {
      ...typography.h3,
    },
    '& h4': {
      ...typography.h4,
    },
    '& img': {
      maxWidth: '100%',
    },
    '& ol': {
      listStyle: 'decimal',
    },
    '& ol, & ul': {
      ...typography.p,
      ...typography.p3,
      marginBottom: spacing.xs,
      marginLeft: spacing.xs,
      paddingLeft: spacing.xs,
    },
    '& p': {
      ...typography.p,
      ...typography.p3,
      '&:last-child': {
        marginBottom: 0,
      },
    },
    borderBottom: 'none',
    paddingBottom: spacing.lg,
  },
});

const Html = ({ classes, fieldDescr }) => (
  <RawHtml className={classnames('form-group', classes.root)}>{fieldDescr}</RawHtml>
);

Html.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  fieldDescr: PropTypes.string.isRequired,
};

const HtmlStyled = withStyles(styles)(Html);

export default withFieldProps()(HtmlStyled);
